const CheckIcon = () => {
    return (
        <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.74794 9.16003C4.55594 9.16003 4.37993 9.09603 4.23593 8.95203L1.05195 5.76803C0.763945 5.48003 0.763945 5.03203 1.05195 4.74403C1.33995 4.45603 1.78793 4.45603 2.07593 4.74403L4.76394 7.41603L11.1479 1.04803C11.4359 0.760029 11.8839 0.760029 12.1719 1.04803C12.4599 1.33603 12.4599 1.78403 12.1719 2.07203L5.27593 8.95203C5.11593 9.09603 4.93994 9.16003 4.74794 9.16003Z" fill="#212224" stroke="#212224" stroke-width="0.5" />
        </svg>

    )
}
export default CheckIcon